/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import ComputoAnualImpl from "components/dashboard/ComputoAnualImpl";
import ControlAsistenciaHoy from "components/dashboard/ControlAsistenciaHoy";
import IncidenciasEnVacaciones from "components/dashboard/IncidenciasEnVacaciones";
import MostrarNotidciaciones from "components/validarVacaciones/MostrarNotidciaciones";
import { Row, Col } from "reactstrap";


const Index = () => {
  const bloques = [
    <MostrarNotidciaciones key="notificaciones" />,
    <ComputoAnualImpl key="computo-anual" />,
    <ControlAsistenciaHoy key="control-asistencia" />,
    <IncidenciasEnVacaciones key="incidencias-vacaciones" />,
  ];

  return (
    <>
      <Row>
        {bloques.map((bloque, index) => (
          <Col key={index} xs="12" lg="6" className="mb-4">
            {bloque}
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Index;
